import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=414c9712&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('414c9712')) {
      api.createRecord('414c9712', component.options)
    } else {
      api.reload('414c9712', component.options)
    }
    module.hot.accept("./Permissions.vue?vue&type=template&id=414c9712&", function () {
      api.rerender('414c9712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/employees/Permissions.vue"
export default component.exports